var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 112,
    viewBox: "0 0 136 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 43.9995C137.669 90.9163 99.4457 112 69.3092 112C39.1727 112 0 86.6587 0 59.6692C0 32.6796 7.19355 15.8729 37.5085 5.46562C67.8235 -4.94168 130.331 -2.91726 134 43.9995Z",
    fill: "#FAFAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36940_138758)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7625 28.168C49.7625 24.7615 52.524 22 55.9305 22H80.0693C83.4758 22 86.2373 24.7615 86.2373 28.168V36.1254H86.9226V42.2934H86.2373V83.832C86.2373 87.2385 83.4758 90 80.0693 90H55.9305C52.524 90 49.7625 87.2385 49.7625 83.832V48.4614H49.0771V42.9787H49.7625V40.9227H49.0771V36.1254H49.7625V28.168ZM53.3795 30.6428C53.3795 27.9933 55.5273 25.8455 58.1768 25.8455H77.8229C80.4724 25.8455 82.6202 27.9933 82.6202 30.6428V81.3572C82.6202 84.0067 80.4724 86.1545 77.8229 86.1545H58.1768C55.5273 86.1545 53.3795 84.0067 53.3795 81.3572V30.6428Z",
    fill: "url(#paint0_linear_36940_138758)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3794 30.643C53.3794 27.9935 55.5272 25.8457 58.1767 25.8457H77.8228C80.4723 25.8457 82.6201 27.9935 82.6201 30.643V81.3575C82.6201 84.0069 80.4723 86.1548 77.8228 86.1548H58.1767C55.5272 86.1548 53.3794 84.0069 53.3794 81.3575V30.643Z",
    fill: "url(#paint1_linear_36940_138758)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36940_138758",
    x1: 96.7105,
    y1: 18.55,
    x2: 33.8603,
    y2: 91.9571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485195,
    stopColor: "#D3D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485295,
    stopColor: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36940_138758",
    x1: 79.2443,
    y1: 2.67252,
    x2: 15.1191,
    y2: 75.1724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485095,
    stopColor: "#F7F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485195,
    stopColor: "#EBEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36940_138758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(34 22)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.18d08c8842e33a9878f3c70fa4f51bc2.svg";
export { ForwardRef as ReactComponent };